import * as React from 'react'
import { clientsSortedByDataPoint } from '../../analytics/algorithms'
import GenericReveal from '../GenericReveal'
import { ISharedStepProps } from './utils'

const Shoesize: React.SFC<ISharedStepProps> = (props) => {
	const algorithmResult = clientsSortedByDataPoint(
		props.state,
		'length'
	).reverse()
	const sendToPhonesAction = () => {
		const sortedIds = algorithmResult.map((v) => v.client._id)
		props.actions.setPositionsFromSortedIdsAction(sortedIds)
		props.actions.updateFirebaseAction()
	}

	return (
		<GenericReveal
			name="On Shoesize"
			results={algorithmResult}
			keysToShow={['length']}
			onClick={sendToPhonesAction}
		/>
	)
}

export default Shoesize
